var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 1.75V3.25H9.25V1.75H12.25ZM4.75 1.75V6.25H1.75V1.75H4.75ZM12.25 7.75V12.25H9.25V7.75H12.25ZM4.75 10.75V12.25H1.75V10.75H4.75ZM13.75 0.25H7.75V4.75H13.75V0.25ZM6.25 0.25H0.25V7.75H6.25V0.25ZM13.75 6.25H7.75V13.75H13.75V6.25ZM6.25 9.25H0.25V13.75H6.25V9.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7d774f3ebcd64506d80cc507bf18db34.svg";
export { ForwardRef as ReactComponent };